import { render, staticRenderFns } from "./RateRenderer.vue?vue&type=template&id=445cdf4a&scoped=true&"
import script from "./RateRenderer.vue?vue&type=script&lang=js&"
export * from "./RateRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445cdf4a",
  null
  
)

export default component.exports